import React from 'react';
import styled from 'styled-components';
import { Box, Button, Inline, Stack } from '@99designs/emu';
import { borders, boxShadows, colors } from '@99designs/emu/settings';
import { IconExclamationPoint1 } from '@99designs/icons';
import { FullscreenOverlay } from '@99designs/spa-common';

const Modal = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 9999;
    transition: 0.25s opacity;
    background-color: rgba(0, 0, 0, 0.3);
    background: radial-gradient(ellipse at center, rgba(0, 0, 0, 0.2) 0, rgba(0, 0, 0, 0.6) 100%);
`;

const ModalContainer = styled(Box)`
    width: 100%;
    position: relative;
    max-height: 100%;
    transition: 0.15s max-width;
    overflow: auto;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    background: ${colors.white};
    border-radius: ${borders.borderRadiuses.small};
    box-shadow: ${boxShadows.medium};
    max-width: 450px;
    text-align: center;
`;

interface FileDownloadExtensionValidationModalProps {
    onConfirm: () => void;
    onClose: () => void;
}
function FileDownloadExtensionValidationModal({
    onConfirm,
    onClose,
}: FileDownloadExtensionValidationModalProps) {
    return (
        <FullscreenOverlay transparent isActive isScrollableSmallScreens>
            <Modal>
                <ModalContainer paddingY="2bu" paddingX="3bu">
                    <Stack space="2bu">
                        <IconExclamationPoint1 height="48px" width="48px" color={colors.grey700} />

                        <>
                            <p>{__('This is an unknown or non-image file type.')}</p>
                            <p>
                                {__(
                                    'Please exercise caution when downloading and using this file.'
                                )}
                            </p>
                        </>

                        <Inline space="0.5bu">
                            <Button onClick={onConfirm} appearance="primary" type="submit">
                                {__('Download')}
                            </Button>
                            <Button onClick={onClose} appearance="secondary" type="submit">
                                {__('Cancel')}
                            </Button>
                        </Inline>
                    </Stack>
                </ModalContainer>
            </Modal>
        </FullscreenOverlay>
    );
}

export default FileDownloadExtensionValidationModal;
